import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Logo from "./Logo";
import { navLinks, site } from "../data/site";

export default function Footer() {
  const legal = [
    { label: "Politique de confidentialité", to: "/politique-de-confidentialite" },
    { label: "Mentions légales", to: "/mentions-legales" },
  ];
  return (
    <footer className="bg-forest-dark grain text-sand" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pt-16 lg:pt-20 pb-24 md:pb-10">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <Logo light />
            <p className="mt-5 font-serif italic text-xl text-sand/90">« {site.tagline} »</p>
            <p className="mt-3 text-sm leading-relaxed text-sand/60 max-w-xs">{site.baseline}</p>
            {site.social.length > 0 && (
              <div className="mt-6 flex gap-3">
                {site.social.map((s, i) => (
                  <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-sand/10 hover:bg-sand/20 transition-colors" aria-label={s.name}>
                    {s.icon}
                  </a>
                ))}
              </div>
            )}
          </div>

          <div>
            <h3 className="text-[11px] uppercase tracking-[0.28em] font-semibold text-moss">Navigation</h3>
            <ul className="mt-5 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.to.replace("/", "") || "accueil"}`} className="text-sm text-sand/70 hover:text-sand transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/demander-un-devis" data-testid="footer-link-devis" className="text-sm font-semibold text-sand hover:text-white transition-colors underline underline-offset-4 decoration-moss/60">
                  Demande de devis
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] uppercase tracking-[0.28em] font-semibold text-moss">Informations</h3>
            <ul className="mt-5 space-y-2.5">
              {legal.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.to.replace("/", "")}`} className="text-sm text-sand/70 hover:text-sand transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li className="pt-3">
                <span className="block text-[11px] uppercase tracking-[0.28em] font-semibold text-moss mt-4 mb-2">Zones desservies</span>
              </li>
              <li><Link to="/jardinier-charleroi" data-testid="footer-zone-charleroi" className="text-sm text-sand/70 hover:text-sand transition-colors">Jardinier à Charleroi</Link></li>
              <li><Link to="/jardinier-namur" data-testid="footer-zone-namur" className="text-sm text-sand/70 hover:text-sand transition-colors">Jardinier à Namur</Link></li>
              <li><Link to="/jardinier-mons" data-testid="footer-zone-mons" className="text-sm text-sand/70 hover:text-sand transition-colors">Jardinier à Mons</Link></li>
              <li className="pt-2 text-sm text-sand/50">{site.name}</li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] uppercase tracking-[0.28em] font-semibold text-moss">Contact</h3>
            <ul className="mt-5 space-y-3.5 text-sm text-sand/70">
              <li className="flex items-start gap-3">
                <Phone size={15} className="mt-0.5 text-moss shrink-0" />
                <a href={site.phoneHref} data-testid="footer-phone-link" className="hover:text-sand transition-colors">{site.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="mt-0.5 text-moss shrink-0" />
                <a href={`mailto:${site.email}`} data-testid="footer-email-link" className="hover:text-sand transition-colors break-all">{site.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-0.5 text-moss shrink-0" />
                <span>{site.zone}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={15} className="mt-0.5 text-moss shrink-0" />
                <span>{site.horaires[0].jours} : {site.horaires[0].heures}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-sand/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-sand/50">© {new Date().getFullYear()} {site.name}. Tous droits réservés.</p>
          <p className="text-xs text-sand/40">Jardinage — Entretien des espaces verts — Aménagement extérieur</p>
        </div>
      </div>
    </footer>
  );
}
